import { faker } from '@faker-js/faker'

import {
  AdminTreatmentCreateRequest,
  AnesthesiaType,
  OperationType,
  TreatmentTimeUnit,
} from '../../contracts/treatment'
import { asBuilder } from '../asBuilder'

export const getAdminTreatmentCreateRequest = asBuilder((): AdminTreatmentCreateRequest => {
  return {
    treatmentGroupIds: faker.helpers.multiple(() => faker.number.int()),
    type: faker.helpers.enumValue(OperationType),
    names: [
      { language: 'ko', value: faker.lorem.word() },
      { language: 'ja', value: faker.lorem.word() },
      { language: 'en', value: faker.lorem.word() },
    ],
    concernIds: faker.helpers.multiple(() => faker.number.int()),
    recommendedTreatmentIds: faker.helpers.multiple(() => faker.number.int()),
    similarTreatmentIds: faker.helpers.multiple(() => faker.number.int()),
    descriptions: {
      recommendedTimes: faker.number.int(),
      procedureTime: { type: TreatmentTimeUnit.MINUTES, value: faker.number.int() },
      recommendedCycle: { type: faker.helpers.enumValue(TreatmentTimeUnit), value: faker.number.int() },
      effectOnSetPeriod: { type: faker.helpers.enumValue(TreatmentTimeUnit), value: faker.number.int() },
      durationPeriod: { type: faker.helpers.enumValue(TreatmentTimeUnit), value: faker.number.int() },
      downtime: { type: faker.helpers.enumValue(TreatmentTimeUnit), value: faker.number.int() },
      anesthesia: faker.helpers.multiple(() => faker.helpers.enumValue(AnesthesiaType)),
      translatedDescriptions: [
        {
          language: 'ko',
          description: faker.lorem.sentence(),
          pros: faker.lorem.sentence(),
          cons: faker.lorem.sentence(),
          painDescription: faker.lorem.sentence(),
          sideEffect: faker.lorem.sentence(),
          caution: faker.lorem.sentence(),
        },
        {
          language: 'ja',
          description: faker.lorem.sentence(),
          pros: faker.lorem.sentence(),
          cons: faker.lorem.sentence(),
          painDescription: faker.lorem.sentence(),
          sideEffect: faker.lorem.sentence(),
          caution: faker.lorem.sentence(),
        },
        {
          language: 'en',
          description: faker.lorem.sentence(),
          pros: faker.lorem.sentence(),
          cons: faker.lorem.sentence(),
          painDescription: faker.lorem.sentence(),
          sideEffect: faker.lorem.sentence(),
          caution: faker.lorem.sentence(),
        },
      ],
    },
  }
})
